import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { applyHeadMeta, resolveSeo } from '@/lib/seo';
import { buildJsonLd } from '@/lib/jsonLd';

export default function SeoManager() {
  const { pathname } = useLocation();

  useEffect(() => {
    applyHeadMeta(resolveSeo(pathname));
  }, [pathname]);

  const schemas = buildJsonLd(pathname);

  return (
    <>
      {schemas.map((schema, index) => (
        <script
          key={index}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
      ))}
    </>
  );
}